export const fmtEur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })}`;
export const fmtKwh = (n) => `${Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 0 })} kWh`;
export const fmtNum = (n, d = 0) => Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: d });

export const STATUS_LABELS = {
  new_lead: "Nuovo lead",
  contacted: "Contattato",
  site_visit: "Sopralluogo",
  simulation: "Simulazione",
  quote_sent: "Preventivo inviato",
  negotiation: "In trattativa",
  won: "Chiuso vinto",
  lost: "Chiuso perso",
  installed: "Installato",
};

export const STATUS_ORDER = ["new_lead", "contacted", "site_visit", "simulation", "quote_sent", "negotiation", "won", "lost"];

export const STATUS_COLORS = {
  new_lead: "#94A3B8",
  contacted: "#0EA5C4",
  site_visit: "#E0A82E",
  simulation: "#E0A82E",
  quote_sent: "#E0A82E",
  negotiation: "#F97316",
  won: "#22A85A",
  lost: "#E11D48",
  installed: "#22A85A",
};
